import { useState, useCallback } from "react"
import type { ViewMode } from "@/components/dashboard/view-toggle"

const STORAGE_KEY = "qr:view-preference"

function isViewMode(value: unknown): value is ViewMode {
  return value === "grid" || value === "list"
}

export function useViewPreference(fallback: ViewMode = "grid"): [ViewMode, (view: ViewMode) => void] {
  const [view, setViewState] = useState<ViewMode>(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY)
      return isViewMode(stored) ? stored : fallback
    } catch {
      return fallback
    }
  })

  const setView = useCallback((next: ViewMode) => {
    setViewState(next)
    try {
      localStorage.setItem(STORAGE_KEY, next)
    } catch {
      // localStorage unavailable
    }
  }, [])

  return [view, setView]
}
